// extracted by mini-css-extract-plugin
export default {"items":"Home_items__0Asvk"};